var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReschedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9917 0.806497C13.0648 -0.268258 14.8054 -0.268915 15.8793 0.805026L19.037 3.96272C20.1018 5.0275 20.1129 6.75126 19.0618 7.82963L8.38546 18.7836C7.67993 19.5075 6.71227 19.9157 5.70184 19.9157L2.24909 19.9155C0.969843 19.9155 -0.0517688 18.8491 0.00203162 17.57L0.149447 14.0653C0.188945 13.1263 0.579224 12.2363 1.24306 11.5714L11.9917 0.806497ZM14.8195 1.86649C14.3313 1.37833 13.5402 1.37863 13.0524 1.86716L10.9365 3.98621L15.8876 8.93731L17.9884 6.78187C18.4662 6.2917 18.4612 5.50817 17.9772 5.02418L14.8195 1.86649ZM2.30372 12.6321L9.87667 5.04767L14.8406 10.0116L7.31207 17.7359C6.88876 18.1702 6.30816 18.4151 5.7019 18.4151L2.24916 18.4149C1.82274 18.4149 1.4822 18.0595 1.50014 17.6331L1.64755 14.1284C1.67125 13.565 1.90542 13.031 2.30372 12.6321ZM19.6285 19.8331C20.0426 19.8331 20.3783 19.4972 20.3783 19.0828C20.3783 18.6685 20.0426 18.3326 19.6285 18.3326H12.7382C12.3242 18.3326 11.9885 18.6685 11.9885 19.0828C11.9885 19.4972 12.3242 19.8331 12.7382 19.8331H19.6285Z",
    fill: "#178477"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReschedule);
export default __webpack_public_path__ + "static/media/reschedule.b6b965b8c664cb76c5979ead5094f091.svg";
export { ForwardRef as ReactComponent };